import { toast as rht } from "react-hot-toast";
import { AlertCircle, Check, X } from "lucide-react";

const BASE = {
  duration: 3200,
  position: "top-center",
};

const ToastCard = ({ t, tone, icon, title, children, action }) => (
  <div
    className={`qh-toast qh-toast--${tone}${t.visible ? " is-visible" : ""}`}
    role="status"
  >
    <div className="qh-toast__icon" aria-hidden>
      {icon}
    </div>
    <div className="qh-toast__body">
      {title ? <div className="qh-toast__title">{title}</div> : null}
      {children ? <div className="qh-toast__msg">{children}</div> : null}
      {action}
    </div>
    <button
      type="button"
      className="qh-toast__close"
      aria-label="Dismiss"
      onClick={() => rht.dismiss(t.id)}
    >
      <X size={14} strokeWidth={2.25} />
    </button>
  </div>
);

const success = (msg) =>
  rht.custom(
    (t) => (
      <ToastCard
        t={t}
        tone="success"
        title="Success"
        icon={<Check size={16} strokeWidth={2.5} />}
      >
        {msg}
      </ToastCard>
    ),
    BASE
  );

const error = (msg) =>
  rht.custom(
    (t) => (
      <ToastCard
        t={t}
        tone="error"
        title="Something went wrong"
        icon={<AlertCircle size={16} strokeWidth={2.25} />}
      >
        {msg}
      </ToastCard>
    ),
    { ...BASE, duration: 4200 }
  );

const promise = (myPromise, msgObj) =>
  rht.promise(myPromise, msgObj, {
    ...BASE,
    className: "qh-hot-toast",
    success: { className: "qh-hot-toast qh-hot-toast--success" },
    error: { className: "qh-hot-toast qh-hot-toast--error" },
    loading: { className: "qh-hot-toast qh-hot-toast--loading" },
  });

const toast = {
  success,
  error,
  promise,
};

export default toast;
